import type * as lazyIndex from './lazyIndex';
import {
    type LazyComponent,
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
} from 'owa-bundling';
import type { EntryPointContainerProps } from './components/SearchPlusChatEntryPointContainer';
import { searchSessionEnded } from 'owa-search-actions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import('./lazyIndex'), {
    name: 'mail/packages/mail/view/owa-mail-search-plus-chat',
});

// Components
export const SearchPlusChatEntryPointContainer: LazyComponent<
    EntryPointContainerProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.SearchPlusChatEntryPointContainer);

// Orchestrators
registerLazyOrchestrator(searchSessionEnded, lazyModule, m => m.searchSessionEndedOrchestrator);

// Utils
export { isSearchPlusChatFeatureEnabledForSearchSession } from './utils/isSearchPlusChatFeatureEnabledForSearchSession';
